import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import simplePopover from 'simple-popover';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/feature-popover';

Component('tr-feature-popover', {
  mixins: [eventListenerMixin],

  properties: {
    key: String,
    pointTo: String,
    title: String,
    content: String,
    showIcon: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'bottom-left',
    },
    popoverCls: {
      type: String,
      default: '',
    },
    autoShow: {
      type: Boolean,
      default: true,
    },
    closeClickBlank: {
      type: Boolean,
      default: true,
    },
  },

  ready() {
    if (this.autoShow
      && !document.querySelector('.simple-popover.tr-feature-popover')) {
      this.show();
    }

    this.listenTo(document, 'click', this.closePopover.bind(this));
  },

  disconnected() {
    this.stopListening();

    if (this.popover) this.popover.destroy();
    this.popover = null;
  },

  show() {
    this.classList.add('shown');

    this.popover = this.createPopover();
    this.popover.on('popover:beforeDestroy', () => {
      setTimeout(() => {
        const nextPopover = document.querySelector('tr-feature-popover:not(.shown)');
        if (nextPopover) nextPopover.show();
      });

      if (this.key) {
        $.post('/new_feature_confirmations', {
          metadata_key: `${this.key}_shown`,
        });
      }

      return true;
    });
  },

  createPopover() {
    return simplePopover({
      cls: this.getPopoverClassnames(),
      pointTo: $(this.pointTo),
      position: this.position,
      content: this.getPopoverContent(),
      autohide: this.closeClickBlank,
    });
  },

  closePopover(event) {
    if (this.popover
      && closest(event.target, '.tr-feature-popover .close-button')) {
      this.popover.destroy();
      this.popover = null;
    }
  },

  getPopoverClassnames() {
    const classnames = ['tr-feature-popover'];

    if (this.showIcon) classnames.push('show-icon');
    if (this.showCloseButton) classnames.push('show-close-button');
    if (this.popoverCls) classnames.push(this.popoverCls);

    return classnames.join(' ');
  },

  getPopoverContent() {
    return `
      <div class="title">
        ${this.title}
        <span class="feature-popover-icon">新！</span>
      </div>
      </div class="content">
        ${this.content}
      </div>
      <a href="javascript:;" class="close-button"><i class="twr twr-times"></i></a>
    `;
  },
});
